<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content">
      <h2>抖店资源</h2>
      <h3>数据筛选</h3>
      <div>
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small" label-width="90px">
          <el-form-item label="订单编号" prop="orderId">
            <el-input v-model="searchForm.orderId" placeholder="请输入订单编号" clearable></el-input>
          </el-form-item>
          <el-form-item label="商品名称" prop="goodsName">
            <el-input style="width: 215px" v-model="searchForm.goodsName" placeholder="请输入商品名称"></el-input>
          </el-form-item>
          <el-form-item label="收货人信息" prop="postUserInfo">
            <el-input style="width: 215px" v-model="searchForm.postUserInfo" placeholder="请输入收货人信息"></el-input>
          </el-form-item>
          <el-form-item label="下单时间" prop="brandId">
            <el-date-picker style="width: 215px" v-model="createTime" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="订单状态" prop="orderStatus">
            <el-select v-model="searchForm.orderStatus" placeholder="请选择订单状态" filterable clearable>
              <el-option v-for="item in dictionaries.dou_order_status" :key="item.dictId" :label="item.dictName"
                :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="导出状态" prop="exportStatus">
            <el-select v-model="searchForm.exportStatus" placeholder="请选择导出状态" filterable clearable>
              <el-option v-for="item in exportStatuss" :key="item.dictId" :label="item.dictName" :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="解密时间" prop="decryptTime">
            <el-date-picker style="width: 215px" v-model="decryptTime" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="导出时间" prop="exportTime">
            <el-date-picker style="width: 215px" v-model="exportTime" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="店铺来源" prop="shopId">
            <el-select v-model="searchForm.shopId" placeholder="请选择店铺来源" filterable clearable>
              <el-option v-for="item in dictionaries.dou_shop_id" :key="item.dictId" :label="item.dictName"
                :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <div style="display: flex; margin-top: 4px">
              <div class="btn-search" @click="fetchData('search')">查询</div>
              <div class="btn-search" style="margin-left: 20px" @click="fetchData('reset')">
                重置
              </div>
            </div>

            <!-- <el-button type="primary" @click="fetchData('search')"
                >查询</el-button
              >
              <el-button type="primary" plain @click="fetchData('reset')"
                >重置</el-button
              > -->
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <h3>列表数据</h3>
        <div style="display:flex">
          <div class="derive" @click="deriveDeliver" style="margin-right:10px">导出</div>
          <div class="derive" @click="deriveDeliverRecord">导出记录</div>
          <!-- <el-button type="primary" @click="deriveDeliver">导出</el-button> -->
        </div>
      </div>
      <orders-list-table v-loading="loading" :dataList="page.list" :heightStr="columns.height" :config="columns.config"
        :typeStr="columns.type" @optionDialog="optionDialog" @lookDialog="lookDialog"
        @tableSelectionChange="tableSelectionChange"></orders-list-table>
      <!-- 分页start -->
      <div class="page" style="float: right; margin: 10px 10px; padding-bottom: 10px">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="page.currentPage" :page-sizes="[3, 5, 10, 20, 50]" :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="page.totalNum">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="导出记录" :visible.sync="dialogRecord" append-to-body width="40%">
      <lb-table :column="columnsDeriveRecord" :data="deriveRecordList.list" pagination :total="deriveRecordList.totalNum"
        layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]" :current-page.sync="pageNo"
        :page-size="pageSize" @size-change="handleSizeChangeDeriveRecord"
        @p-current-change="handleCurrentChangeDeriveRecord">
      </lb-table>

      <div style="margin-top: 20px; text-align: center">
        <el-button @click="dialogRecord = false" plain style="margin-right: 20px">取消</el-button>
        <el-button type="primary" @click="dialogRecord = false">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumbTop from '../../components/breadcrumb.vue'
import LbTable from '../../components/lb-table/lb-table'
import OrdersListTable from './components/OrdersListTableL'
export default {
  components: {
    breadcrumbTop,
    LbTable,
    OrdersListTable
  },
  data() {
    return {
      pageNo: 1,
      pageSize: 10,
      dialogRecord: false,
      deriveRecordList: {
        list: [],
        totalNum: 0,
      },
      payTime: [],
      exportStatuss: [
        {
          dictId: '1',
          dictName: '已导出'
        },
        {
          dictId: '0',
          dictName: '未导出'
        }
      ],
      dataList: {
        list: [
          { title: '客户管理', path: '', type: '0' },
          { title: '抖店资源', path: '', type: '1' }
        ]
      },
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        orderId: '',
        goodsName: '',
        postUserInfo: '',
        createTimeStart: '',
        createTimeEnd: '',
        orderStatus: '',
        exportStatus: '',
        exportTimeStart: '',
        exportTimeEnd: '',
        decryptTimeStart: '',
        decryptTimeEnd: '',
        shopId: '',
        orderIds: []
      },
      createTime: [],
      exportTime: [],
      decryptTime: [],
      list: [
        {
          name: '天兰',
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        },
        {
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        },
        {
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        }
      ],
      // columns: [
      //   { type: 'selection', minWidth: '80', fixed: 'left' },
      //   { label: '订单编号', prop: 'userId', minWidth: '90' },
      //   { label: '商品信息', prop: 'nickName', minWidth: '200' },
      //   { label: '单价数量', prop: 'phone', minWidth: '100' },
      //   { label: '应付', prop: 'vipLevelName', minWidth: '120' },
      //   { label: '下单时间', prop: 'platformName', minWidth: '200' },
      //   {
      //     label: '收货人信息', prop: 'awaitCommissionAmount', minWidth: '120',
      //     render: (h, scope) => {
      //       return (
      //         <div> {Number(scope.row.awaitCommissionAmount).toFixed(2)}</div>
      //       )
      //     }
      //   },
      //   {
      //     label: '店铺来源', prop: 'withdrawCommissionAmount', minWidth: '120',
      //     render: (h, scope) => {
      //       return (
      //         <div> {Number(scope.row.withdrawCommissionAmount).toFixed(2)}</div>
      //       )
      //     }
      //   },
      //   {
      //     label: '订单状态', prop: 'paidCommissionAmount', minWidth: '200',
      //     render: (h, scope) => {
      //       return (
      //         <div> {Number(scope.row.paidCommissionAmount).toFixed(2)}</div>
      //       )
      //     }
      //   },
      //   {
      //     label: '解密时间', prop: 'paidCommissionAmount', minWidth: '200',
      //     render: (h, scope) => {
      //       return (
      //         <div> {Number(scope.row.paidCommissionAmount).toFixed(2)}</div>
      //       )
      //     }
      //   },
      //   {
      //     label: '导出状态',
      //     minWidth: '120',
      //     fixed: 'right',
      //     render: (h, scope) => {
      //       return (
      //         <div>
      //           <span style='color:#4168E7;cursor:pointer' onClick={() => { this.todetail(scope.row) }}>查看</span>
      //         </div >
      //       )
      //     }
      //   }],
      columns: {
        type: 'afterOrder',
        height: '5000px',
        sortObj: {},
        config: [
          { type: 'selection', width: 50 },
          { prop: 'orderId', label: '订单编号', width: 200, slot: 'orderId' },
          { prop: 'goodsInfo', label: '商品信息', slot: 'goodsInfo', width: 480 },

          // { prop: 'price', label: '单价/数量', slot: 'price', width: 180 },
          { prop: 'orderAmount', label: '应付', width: 80, slot: 'orderAmount' },
          { prop: 'createTime', label: '下单时间', width: 200, },
          { prop: 'userInfo', label: '收货人信息', slot: 'userInfo', width: 180 },
          { prop: 'shopName', label: '店铺来源', slot: 'shopName', width: 150 },
          { prop: 'orderStatusLabel', label: '订单状态', width: 100, slot: 'orderStatusLabel' },
          { prop: 'decryptTime', label: '解密时间', width: 100, slot: 'decryptTime' },
          { prop: 'exportStatus', label: '导出状态', width: 100, slot: 'exportStatus' },
          { prop: 'exportTime', label: '导出时间', slot: 'exportTime', width: 180, fixed: 'right' },
        ]
      },
      columnsDeriveRecord: [
        { label: '文件名', prop: 'fileName', minWidth: '230' },
        { label: '操作人', prop: 'userName', minWidth: '100' },
        { label: '导出时间', prop: 'createdDate', minWidth: '200' },
        {
          label: '操作', width: '100',
          render: (h, scope) => {
            return (
              <div>
                <el-link type='primary' size='mini' onClick={() => {
                  this.downloadlink(scope.row.excelUrl)
                }}>下载
                </el-link>
              </div>
            )
          }
        }
      ],
      page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      dictionaries: {},
      loading: true,
      platformList: []
    }
  },
  created() {
    this.getDictionaries('dou_shop_id')
    this.getDictionaries('dou_order_status')

    this.fetchData()
    // this.goodsPlatforms()
  },
  methods: {
    // 每页条数
    handleSizeChangeDeriveRecord(val) {
      // this.page.currentPage = 1
      this.pageSize = val
      this.deriveDeliverRecord()
    },
    // 当前页
    handleCurrentChangeDeriveRecord(val) {
      this.pageNo = val
      this.deriveDeliverRecord()
    },
    tableSelectionChange(e) {
      console.log(e)
      this.searchForm.orderIds = []
      e.forEach(item => {
        this.searchForm.orderIds.push(item.orderId)
      })
    },
    optionDialog() {

    },
    lookDialog() {

    },
    deriveDeliverRecord() {
      this.dialogRecord = true
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      this.axios.get('/outorder/dou/order/decrypt/exportRecordsPage', { params: params }).then(res => {
        if (res.code == 0) {
          this.deriveRecordList.list = res.data.list
          this.deriveRecordList.totalNum = res.data.totalNum
        }
      })
    },
    //导出
    deriveDeliver() {
      if (this.createTime) {
        this.searchForm.createTimeStart = this.createTime[0]
        this.searchForm.createTimeEnd = this.createTime[1]
      } else {
        this.searchForm.createTimeStart = ''
        this.searchForm.createTimeEnd = ''
      }
      if (this.decryptTime) {
        this.searchForm.decryptTimeStart = this.decryptTime[0]
        this.searchForm.decryptTimeEnd = this.decryptTime[1]
      } else {
        this.searchForm.decryptTimeStart = ''
        this.searchForm.decryptTimeEnd = ''
      }
      if (this.exportTime) {
        this.searchForm.exportTimeStart = this.exportTime[0]
        this.searchForm.exportTimeEnd = this.exportTime[1]
      } else {
        this.searchForm.exportTimeStart = ''
        this.searchForm.exportTimeEnd = ''
      }
      this.axios.post('/outorder/dou/order/decrypt/export', this.searchForm).then(res => {
        if (res.code == 0) {
          this.downloadlink(res.data)
          this.$message({
            type: 'success',
            message: '导出成功!'
          })
          this.fetchData('search')
        }
      })
    },
    downloadlink(url) {
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = url
      document.body.appendChild(iframe)
    },
    goodsPlatforms() {
      const params = {
        userId: null,
        username: null,
        phone: null,
        vipLevel: null,
        categoryIds: null,
        openTimeStart: null,
        openTimeEnd: null,
        status: 1
      }
      this.$api.goodsPlatforms(params).then((res) => {
        res.data.forEach(item => {
          if (item.name !== '五域') {
            this.platformList.push(item)
          }
        })
        // this.platformList = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取字典数据
    getDictionaries(type) {
      const params = { groupId: type }
      this.$api.dictionaries(params).then((res) => {
        this.dictionaries[type] = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    onMultipleSelection(val) {
      this.selectionGoods = val
    },
    handleCurrentChange(currentChange) {
      this.searchForm.pageNo = currentChange
      this.fetchData()
    },
    handleSizeChange(sizeChange) {
      this.searchForm.pageSize = sizeChange
      this.fetchData()
    },
    fetchData(type) {
      if (type == 'reset') {
        this.searchForm = {}
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
        this.createTime = []
        this.decryptTime = []
        this.exportTime = []
      }
      if (type == 'search') {
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }

      if (this.createTime) {
        this.searchForm.createTimeStart = this.createTime[0]
        this.searchForm.createTimeEnd = this.createTime[1]
      } else {
        this.searchForm.createTimeStart = ''
        this.searchForm.createTimeEnd = ''
      }
      if (this.decryptTime) {
        this.searchForm.decryptTimeStart = this.decryptTime[0]
        this.searchForm.decryptTimeEnd = this.decryptTime[1]
      } else {
        this.searchForm.decryptTimeStart = ''
        this.searchForm.decryptTimeEnd = ''
      }
      if (this.exportTime) {
        this.searchForm.exportTimeStart = this.exportTime[0]
        this.searchForm.exportTimeEnd = this.exportTime[1]
      } else {
        this.searchForm.exportTimeStart = ''
        this.searchForm.exportTimeEnd = ''
      }
      this.axios.post('/outorder/dou/order/decrypt/pageList', this.searchForm).then(res => {
        if (res.code == 0) {
          this.page.list = res.data.list
          this.page.totalNum = res.data.totalNum
          this.loading = false
        }
      })
    },
    add() {
      this.$router.push({
        name: 'platListDetail',
        query: {}
      })
    },
    setting() {
      this.$router.push({
        name: 'settingPlatform',
        query: {}
      })
    },
    todetail(row) {
      this.$router.push({
        name: 'commissionManageDetail',
        query: {
          platformId: row.platformId
        }
      })
    }
  }
}
</script>
  
<style scoped lang="scss">
.btn-search {
  width: 68px;
  height: 32px;
  background: #e3edff;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 32px;
  color: #4168e7;
  text-align: center;
  cursor: pointer;
}

.derive {
  width: 120px;
  height: 36px;
  background: #4168e7;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: white;
  text-align: center;
  cursor: pointer;
}

.container {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 5px;
}

.title {
  display: flex;
  justify-content: space-between;
}

#base-list {
  margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}

// .search-form {
//   display: flex;
//   flex-wrap: wrap;
//   .el-form-item {
//     /deep/ .el-form-item__label {
//       width: 100px;
//       text-align: right;
//       vertical-align: middle;
//       float: left;
//       box-sizing: border-box;
//     }
//     /deep/ .el-form-item__content {
//       display: block;
//       margin-left: 100px;
//       .el-cascader,
//       .el-select {
//         width: 100%;
//       }
//     }
//   }
// }
</style>
  
  